import { createAction } from '@reduxjs/toolkit';

import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const addToWalletActions = createDataModuleActions('ADD_TO_WALLET');
export const addToWallet = addToWalletActions.dataRequest;
export const addToWalletSuccess = addToWalletActions.dataSuccess;
export const addToWalletError = addToWalletActions.dataError;
export const addToWalletReset = addToWalletActions.dataReset;

export const addToWalletEligible = createAction('ADD_TO_WALLET::ELIGIBLE');

const startWalletProvisioningActions = createDataModuleActions(
    'START_WALLET_PROVISIONING',
);
export const startWalletProvisioning =
    startWalletProvisioningActions.dataRequest;
export const startWalletProvisioningSuccess =
    startWalletProvisioningActions.dataSuccess;
export const startWalletProvisioningError =
    startWalletProvisioningActions.dataError;

const continueWalletProvisioningActions = createDataModuleActions(
    'CONTINUE_WALLET_PROVISIONING',
);
export const continueWalletProvisioning =
    continueWalletProvisioningActions.dataRequest;
export const continueWalletProvisioningSuccess =
    continueWalletProvisioningActions.dataSuccess;
export const continueWalletProvisioningError =
    continueWalletProvisioningActions.dataError;

const virtualProvisioningProvisionActions = createDataModuleActions(
    'VIRTUAL_PROVISIONING_PROVISION',
);
export const virtualProvisioningProvisionRequest =
    virtualProvisioningProvisionActions.dataRequest;
export const virtualProvisioningProvisionSuccess =
    virtualProvisioningProvisionActions.dataSuccess;
export const virtualProvisioningProvisionError =
    virtualProvisioningProvisionActions.dataError;

export const nativeWalletStateInitialized = createAction(
    'NATIVE_WALLET::STATE_INITIALIZED',
);
